import React, { useState } from "react"
import { Box, Textarea, Text, HStack } from "@chakra-ui/react"
import { ChevronRightIcon } from "@chakra-ui/icons"
import { c } from "../classroomColors"

/**
 * The Figma input card: a rounded field with an italic prompt and a
 * "Send →" affordance in the bottom right. Enter sends, Shift+Enter
 * makes a new line.
 */
export function PreClassQuestionInput({ onSubmit, disabled }) {
  const [value, setValue] = useState("")
  const [sending, setSending] = useState(false)

  const handleSubmit = async () => {
    const text = value.trim()
    if (!text || sending || disabled) return
    setSending(true)
    try {
      if (onSubmit) await onSubmit(text)
      setValue("")
    } finally {
      setSending(false)
    }
  }

  const canSend = Boolean(value.trim()) && !sending && !disabled

  return (
    <Box
      width="100%"
      maxWidth="520px"
      borderRadius="10px"
      border="1px solid"
      borderColor={c.inputBorder}
      background={c.inputBg}
      position="relative"
      transition="border-color 0.15s"
      _focusWithin={{ borderColor: c.accent, boxShadow: `0 0 0 1px ${c.accent}` }}
    >
      <Textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            handleSubmit()
          }
        }}
        border="none"
        resize="none"
        height="84px"
        padding="12px 16px 30px"
        fontSize="12px"
        color={c.text}
        background="transparent"
        _focusVisible={{ boxShadow: "none" }}
        _placeholder={{
          color: c.textMuted,
          fontSize: "12px",
          fontStyle: "italic",
          fontWeight: 300,
        }}
        placeholder="Leave your questions to the teacher"
      />
      <HStack
        spacing="2px"
        position="absolute"
        bottom="8px"
        right="14px"
        cursor={canSend ? "pointer" : "default"}
        opacity={canSend ? 1 : 0.45}
        transition="opacity 0.15s"
        onClick={handleSubmit}
        role="button"
        aria-label="Send question"
      >
        <Text color={c.text} fontSize="11px" fontWeight="500">
          {sending ? "Sending…" : "Send"}
        </Text>
        {!sending && <ChevronRightIcon boxSize={3} color={c.text} />}
      </HStack>
    </Box>
  )
}
